import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';
import { editNewbornDueDate } from '../api/editNewbornDueDate';

export const editDueDateMutationAtom = atomWithMutation<void, Date, Error>(
    (get) => ({
        mutationFn: async (dueDate: Date) => await editNewbornDueDate(dueDate),
        onSuccess: async () =>
            await get(queryClientAtom).invalidateQueries({
                queryKey: ['newborn-program'],
            }),
    }),
);
